import { render, staticRenderFns } from "./CommUser.vue?vue&type=template&id=e8d235da&scoped=true"
import script from "./CommUser.vue?vue&type=script&lang=js"
export * from "./CommUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d235da",
  null
  
)

export default component.exports